<template>
    <div class="msg-menu">
        <p class="title">
            通知与公告
        </p>
        <div v-for="msg in msgList" class="msg-item">
            <i class="iconfont" :class="{'icon-warning1':msg.type==='warning','icon-remind1':msg.type==='remind1','icon-information':msg.type==='information',}"></i>
            <p>{{msg.msg}}</p>
            <p class="time">{{msg.time}}</p>
        </div>
        <p>
            <router-link to="/user/msgList">查看更多</router-link>
        </p>
    </div>
</template>

<script>
    export default {
        name: "msgMenu",
        data() {
            return {
                msgList: [{
                    time: "2011",
                    msg: "这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息",
                    type: "remind1"
                }, {
                    time: "2011",
                    msg: "这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息",
                    type: "information"
                }, {
                    time: "2011",
                    msg: "这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息",
                    type: "warning"
                }]

            }
        },

    }
</script>

<style scoped>
    .msg-menu {
        width: 100%;
        box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, .3);
        display: flex;
        flex-direction: column;
        background: white;
        color:#747474;
        line-height: 1.2
    }
    .msg-menu>*{
        border-top:1px solid #ccc;
    }
    .msg-menu>.title{
        border-top:none;
        text-align: left;
        padding: 14px 16px;
        font-size: 18px;

    }
    .msg-menu>p{
        text-align: center;
        font-size: 16px;
        padding: 10px 0 8px;
    }
    .msg-item{
        padding:17px 10px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
    }
    .msg-item>i{
        font-size: 33px;
    }
    .msg-item>p:nth-child(2){
        padding: 0 20px;

    }
    .msg-item>p:nth-child(3){
        font-size: 10px;

    }
    a{
        color:#747474;
    }
    .icon-warning1{
        color: #ff5353 ;
    }
    i{
        color:#057efb;
    }


</style>



// WEBPACK FOOTER //
// msgMenu.vue?245dc75c